<template>
  <div>
    <vs-popup class="user-edit-popup"
              id="popup"
              :title="`Number Sequence - ${sequenceName}`"
              @close="open = false"
              :active.sync="open"
              :buttons-hidden="true"
    >
      <div class="mb-2 vx-row">
        <div class="w-full vx-col md:w-1/2 md:mb-0 mt-5">
          <vs-button v-if="is_editable" @click="addCard" icon-pack="feather" icon="icon-plus" class="shadow-sm ml-6" color="success"
                     size="medium">
            Add New Section
          </vs-button>
        </div>
        <div class="w-full vx-col md:w-1/2 md:mb-0">
          <small class="label">Example preview</small>
          <vs-input size="large" readonly class="w-full" name="length" type="text" v-model="preview"/>
        </div>
      </div>
      <vs-row vs-w="12" class="mt-4">
        <vs-col v-for="(content,index) in sequence" :key="index+'content'"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="6" vs-sm="6" vs-xs="12"
                class="px-4 pb-4">
          <vx-card-custom
            titleColor="#736F6E"
            class="my-8"
            :subtitle="index+1+''"
            :remove-card-action="(sequence.length > 1 && is_editable)"
            v-on:remove="removeCard(index)"
          >
            <div class="vx-row mb-3 mt-4">
              <div class="vx-col w-full md:mb-0">
                <small class="label">Type <span class="text-danger">*</span></small>
                <v-select :disabled="!is_editable" label="type" :closeOnSelect="true" :options="typeList"
                          v-model="sequence[index].type"/>
              </div>
            </div>
            <!--        <div class="vx-row mb-3 mt-4">-->
            <!--          <div class="vx-col w-full md:mb-0">-->
            <!--            <small class="label">Order</small>-->
            <!--            <vs-input readonly class="w-full" name="order" type="text" v-model="sequence[index].order"/>-->
            <!--          </div>-->
            <!--        </div>-->
            <div class="vx-row mb-3 mt-4">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <small class="label">Separator</small>
                <vs-input :disabled="!is_editable" class="w-full" name="separator" type="text" v-model="sequence[index].separator"/>
              </div>
              <template v-if="!(sequence[index].type === 'raw material' || sequence[index].type === 'formulation')">
              <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'string'">
                <small class="label">Value <span class="text-danger">*</span></small>
                <vs-input :disabled="!is_editable" class="w-full" name="value" type="text" v-model="sequence[index].value"/>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'number'">
                <small class="label">Length <span class="text-danger">*</span> </small>
                <vs-input :disabled="!is_editable" class="w-full" name="length" type="text" v-model="sequence[index].length"/>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'number'">
                <small class="label">Prefix Value</small>
                <vs-input :disabled="!is_editable" class="w-full" name="prefix_value" type="text" v-model="sequence[index].prefix_value"/>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'number'">
                <small class="label">Starting Number</small>
                <vs-input :disabled="!is_editable" class="w-full" name="starting_number" type="text" v-model="sequence[index].starting_number"/>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="sequence[index].type === 'date'">
                <small class="label">Format <span class="text-danger">*</span></small>
                <v-select :disabled="!is_editable" label="key" :closeOnSelect="true" :options="dateFormats" v-model="sequence[index].format"
                          :reduce="option => option.value"/>
              </div>
              </template>
            </div>
          </vx-card-custom>
        </vs-col>
      </vs-row>
      <div v-if="is_editable" class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click="submitChanges" class="ml-auto mt-2">Save Changes</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import vSelect from 'vue-select'
import SuccessMessage from "@/mixins/SuccessMessage";
import ErrorMessages from "@/mixins/ErrorMessages";
import moment from "moment";

const TenantSettingRepository = RepositoryFactory.get('settings')
export default {
  name: "SequenceUpdatePopUp",
  data() {
    return {
      open: false,
      sequenceId: null,
      sequenceName: '',
      sequence: [],
      dateFormats: [
        {key:'d/m/Y (ex: 31/08/2022)', value: 'd/m/Y', preview: '31/08/2022'},
        {key:'m/d/Y (ex: 08/31/2022)', value: 'm/d/Y', preview: '08/31/2022'},
        {key:'d/m/y (ex: 31/08/22)', value: 'd/m/y', preview: '31/08/22'},
        {key:'m/d/y (ex: 08/31/22)', value: 'm/d/y', preview: '08/31/22'},
        {key:'Y-m-d (ex: 2022-08-31)', value: 'Y-m-d', preview: '2022-08-31'},
        {key:'d-m-Y (ex: 31-08-2022)', value: 'd-m-Y', preview: '31-08-2022'},
        {key:'m-d-Y (ex: 08-31-2022)', value: 'm-d-Y', preview: '08-31-2022'},
        {key:'d-m-y (ex: 31-08-22)', value: 'd-m-y', preview: '31-08-22'},
        {key:'m-d-y (ex: 08-31-22)', value: 'm-d-y', preview: '08-31-22'},
      ],
      typeList: null ,
      formattedPayload: {},
      seqName:'',
      preview: '',
      is_editable: false
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
  },
  methods: {
    openPopUp(sequenceId,  sequenceName) {
      this.typeList = ['string','number','date']
      this.open = true
      this.tenantId = this.$route.params.id
      this.sequenceId = sequenceId
      this.sequenceName = sequenceName
      this.loadSequence()
    },
    async loadSequence() {
      this.$vs.loading()
      const {data} = await TenantSettingRepository.getTenantSequence(this.tenantId, this.sequenceId)
      this.sequence = data.data
      this.is_editable = data.is_editable
      if(data.name === 'Raw Material Code') {
        this.typeList.push('raw material')
      }
      if(data.name === 'Formulation Code') {
        this.typeList.push('formulation')
      }
      this.$vs.loading.close()
      this.generatePreview()
    },
    async submitChanges() {
      this.$vs.loading()
      const vue = this
      this.sequence.forEach((content, index) => {
        this.sequence[index].order = index + 1
      })

      this.sequence.forEach((content, index) => {

        if (content.type === 'string') {
          this.formattedPayload[index] = {
            type: content.type,
            order: content.order,
            value: content.value,
            separator: content.separator
          }
        }

        if (content.type === 'date') {
          this.formattedPayload[index] = {
            type: content.type,
            order: content.order,
            format: content.format,
            separator: content.separator
          }
        }

        if (content.type === 'number') {
          this.formattedPayload[index] = {
            type: content.type,
            order: content.order,
            length: content.length,
            separator: content.separator,
            prefix_value:content.prefix_value,
            starting_number:content.starting_number,
          }
        }

        if(content.type === 'raw material') {
          this.formattedPayload[index] = {
            order: content.order,
            type: 'raw_material',
            separator: content.separator
          }
        }
        if(content.type === 'formulation') {
          this.formattedPayload[index] = {
            order: content.order,
            type: 'formulation',
            separator: content.separator
          }
        }
      })
      const payload = {
        data: this.formattedPayload
      }
      try {
        const {data} = await TenantSettingRepository.updateTenantSequence(this.tenantId, this.sequenceId, payload)
        await vue.$parent.refreshData()
        this.open = false
        this.showSuccessMessage('Sequence Updated Successfully')
      } catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    addCard() {
      const newObject = {
        separator: '',
        type: 'string',
        value: ''
      }
      this.sequence.push(newObject)
    },
    removeCard(cardIndex) {
      this.sequence.splice(cardIndex, 1)
    },
    generatePreview() {
      this.preview = ''
      this.sequence.forEach((content, index) => {
        const separator = content.separator && (this.sequence.length - 1 !== index) ? content.separator : ''
        if (content.type === 'string') {
          this.preview = `${this.preview}${content.value}${separator}`
        }
        if (content.type === 'raw material' || content.type === 'raw_material') {
          this.preview = `${this.preview}OIL${separator}`
        }
        if (content.type === 'formulation') {
          this.preview = `${this.preview}NATSD${separator}`
        }
        if (content.type === 'number') {
          const missingNumberCount = content.length - (content.prefix_value ? content.prefix_value.length : 0 + content.starting_number ? content.starting_number.length : 0)
          let zeroString = ''
          for (var i = missingNumberCount; i > 0; i--){
            zeroString = `${zeroString}0`
          }
          const num = `${content.prefix_value?content.prefix_value: ''}${zeroString}${content.starting_number? content.starting_number : ''}`
          this.preview = `${this.preview}${num}${separator}`
        }
        if (content.type === 'date') {
          const dateFormatObj = this.dateFormats.find(obj => obj.value === content.format)
          this.preview = `${this.preview}${dateFormatObj && dateFormatObj.preview ? dateFormatObj.preview : ''}${separator}`
        }
      })
    },
    async generateZeroString(number){
      for (let i = 10; i < 10 ; i ++){
        console.log("numbering")
      }
    }
  },
  watch: {
    sequence: {
      handler() {
        this.generatePreview()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.user-edit-popup  >>> .vs-popup  {
  width: 80%;
}
</style>
